import { MouseEventHandler, ReactNode } from "react";
import "./Button.scss";
import { Link, useNavigate } from "react-router-dom";

const ButtonContent = ({
  icon,
  text,
  trailingIcon,
}: {
  icon?: ReactNode;
  text: string;
  trailingIcon?: ReactNode;
}) => (
  <>
    {icon ? <span className="Button__icon">{icon}</span> : null}
    {text}
    {trailingIcon ? <span className="Button__icon Button__icon--trailing">{trailingIcon}</span> : null}
  </>
);

const Button = (props: {
  text: string;
  icon?: ReactNode;
  trailingIcon?: ReactNode;
  disabled?: boolean;
  linkTo?: string;
  type?: "cancel" | "inverse" | "navy" | "stats";
  onClick?: MouseEventHandler<HTMLButtonElement>;
  submit?: boolean;
  linkState?: any;
  external?: boolean;
}) => {
  const navigate = useNavigate();
  const buttonClicked = () => {
    if (props.linkTo) {
      if (props.external) {
        window.open(props.linkTo, "_blank", "noopener,noreferrer");
      } else {
        navigate(props.linkTo);
      }
    }
  };

  if (props.linkTo) {
    if (props.external) {
      return (
        <div className="Button">
          <a href={props.linkTo} target="_blank" rel="noopener noreferrer" className={props.type}>
            <ButtonContent icon={props.icon} trailingIcon={props.trailingIcon} text={props.text} />
          </a>
        </div>
      );
    }
    return (
      <div className="Button">
        <Link to={props.linkTo} className={props.type} state={props.linkState}>
          <ButtonContent icon={props.icon} trailingIcon={props.trailingIcon} text={props.text} />
        </Link>
      </div>
    )
  }

  return (
    <div className="Button">
      <button
        disabled={props.disabled}
        onClick={props.onClick ? props.onClick : buttonClicked}
        className={props.type + ' ' + (props.disabled ? 'disabled' : '')}
        type={props.submit ? "submit" : "button"}
      >
        <ButtonContent icon={props.icon} trailingIcon={props.trailingIcon} text={props.text} />
      </button>
    </div>
  );
};

export default Button;
